import React, { useMemo, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "antd/lib/modal";
import Tooltip from "antd/lib/tooltip";
import config1 from "../../../config";
import IsDarkPost from "../../../assets/Dark_Post.svg";
import shareQ from "../../../assets/share_q.svg";
import shareQwhite from "../../../assets/share_q_white.svg";
import Interaction from "../../../assets/WidgetMaker/Interaction.svg";
import deepLinkIcon from "../../../assets/deepLink_Icon.svg";
import deepLinkIconCC from "../../../assets/CommandCenter/ticketDetails_commandcenter.svg";
import FB_Like from "../../../assets/FB_Like.svg";
import FB_like_white from "../../../assets/deepDive/FB_like_white.svg";
import upvote from "../../../assets/upvote.svg";
import upvotewhite from "../../../assets/upvote_white.svg";
import fb_share from "../../../assets/fb_share.svg";
import fb_share_white from "../../../assets/fb_share_white.svg";
import instaShare from "../../../assets/insta_share.svg";
import instaShareWhite from "../../../assets/insta_share_white.svg";
import Youtube_Share from "../../../assets/Youtube_Share.svg";
import Youtube_Share_white from "../../../assets/Youtube_Share_white.svg";
import Video_view from "../../../assets/Video_view.svg";
import Video_view_white from "../../../assets/Video_view_white.svg";
import trendsIcon from "../../../assets/Trend.svg";
import reTweet from "../../../assets/deepDive/reTweet.svg";
import reTweetwhite from "../../../assets/deepDive/reTweet_white.svg";
import like from "../../../assets/deepDive/Like.svg";
import likewhite from "../../../assets/deepDive/Like_white.svg";
import comment from "../../../assets/deepDive/comment.svg";
import commentwhite from "../../../assets/deepDive/comment_white.svg";
import postClickWhite from "../../../assets/white_post_click_icon.svg";
import postClickBlack from "../../../assets/black_post_click_icon.svg";
import DeletePostIcon from "../../../assets/CommandCenter/Delete.svg";
import Globe from "../../../assets/CommandCenter/Globe.svg";
import HidePostIcon from "../../../assets/CommandCenter/hidden.svg";
import ViewIcon from "../../../assets/CommandCenter/hidden.svg";
import TrandsView from "../TrandsView";
import Maskimg from "../../../assets/CommandCenter/disabled_visible_blue_commandcenter.svg";
import UnMaskimg from "../../../assets/disabled_visible_gray.svg";
import {
  setWidgetMakerPostCardTrends,
  setWidgetMakerTrandArray,
  setWidgetMakerPostCardShareTrends,
  setDashboardTrendsFlag,
  setUnmaskedInfo,
  getUnmaskedInfo,
} from "../../../redux/actions/WidgetMaker/WidgetAPI";
import userFollowers from "../../../assets/FollowersBlue.svg";
import { kFormatter } from "../../../redux/constants";
import ClockIcon from "../../../assets/Clock.svg";
import isEqual from "react-fast-compare";
import { setOptionHighChart } from "../../../redux/actions/HighChart";
import { setOnClickGlobeCoordinates } from "../../../redux/actions/commandCenter/screens/screen";
import DeletePost from "./DeletePost";
import HidePostModal from "./HidePostModal";
import UnMaskimgCC from "../../../assets/CommandCenter/disabled_visible_gray_commandcenter.svg";
import MaskimgCC from "../../../assets/CommandCenter/disabled_visible_blue_commandcenter.svg";
import { getDynamicChannelIcon } from "../../../redux/constants/ChannelIcons";
import { getDynamicIconColor } from "../../../redux/constants/DynamicIconColor";
import { getCommandCenterIcon } from "../../../redux/constants/PostGalleryIcon";

const CustomFooterContent = ({
  isPreviewState,
  data,
  PdfDownloadStatus,
  PptGeneratingStatus,
  el,
  postDetail,
  footerMetaData,
  isHideGlobal,
  deepDive,
  setAutoPlay,
}) => {
  const dispatch = useDispatch();
  const authParams = useSelector((state) => state.Authentication.authParams);
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const unMaskedInfo = useSelector((state) => state.ApiCall.unMaskedInfo);
  const unMaskedInfoId = useSelector((state) => state.ApiCall.unMaskedInfoId);
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const personalizationSettingsObj = useSelector(
    (state) => state?.PersonalizationSetting
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );
  const [deepLinkModal, setDeepLinkModal] = useState({
    url: null,
    modalShow: false,
  });
  const [trendValue, setTrendvalue] = useState(null);
  const [trandView, setTrandView] = useState({
    modalShow: false,
    data: null,
  });
  const [getunmaskedInfo, setGetunmaskedInfo] = useState(false);
  const [hidePost, setHidePost] = useState({
    modalShow: false,
    data: null,
  });
  const [masked, setMasked] = useState(
    unMaskedInfo !== null
      ? unMaskedInfo.tagids.includes(el?.TagID)
        ? false
        : true
      : true
  );
  const [deletePost, setDeletePost] = useState({
    modalShow: false,
    data: null,
  });

  const handleTrends = (e, id, widgetmakerPostCardTrands) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      return;
    }
    // To Stop Carousel in Brand Post Screen
    if (authParams?.screen_id === "000-000-562") {
      setAutoPlay(false);
    }
    let timer1 = null;
    let timer2 = null;
    dispatch(setDashboardTrendsFlag(true));
    setTrendvalue(e);
    if (shareTemplateData) {
      const d = new Date();
      let utcOffset = d.getTimezoneOffset();
      let tab_array = [
        { widget_id: 0, chart_type: "user_profile", widget_loader: true },
        { widget_id: 1, chart_type: "kpi", widget_loader: true },
        { widget_id: 2, chart_type: "line", widget_loader: true },
        { widget_id: 3, chart_type: "donut", widget_loader: true },
        { widget_id: 4, chart_type: "wordcloud", widget_loader: true },
      ];
      dispatch(setWidgetMakerTrandArray(tab_array));

      setTrandView({
        modalShow: true,
        data: e,
      });
      tab_array = tab_array?.map((el, i) => {
        let obj = {
          ...el,
          card_type: e?.card_type,
          content_id: e?.PostContentID,
          brand_id: e?.PostBrandID,
          author_id: e?.AuthorAuthorID,
          post_id: e?.PostPostID,
          retweet_id: e?.RetweetedStatusID,
          reply_id: e?.InReplytostatusID,
          channel_group_id: e?.PlatformID,
          tag_id: e?.TagID ? e?.TagID : e?.tagid,
          utcOffset: utcOffset,
          offset: 0,
          isVerified: 0,
          sentimentType: {
            ispositive: 0,
            isnegative: 0,
            isneutral: 0,
          },
          trends_duration: el?.widget_id === 2 ? "eight_hours" : 0,
          isreply: 0,
          isretweet: 0,
          isreplywmedia: 0,
          attribute: "followers",
          sort_order: "desc",
          uniqueid: e?.uniqueid,
        };
        return obj;
      });
      timer1 = setTimeout(() => {
        tab_array?.forEach((el) => {
          shareCategory?.id &&
            dispatch(
              setWidgetMakerPostCardShareTrends(shareCategory, el, tab_array)
            );
        });
      }, 200);
    } else {
      const d = new Date();
      let utcOffset = d.getTimezoneOffset();
      let tab_array = widgetmakerPostCardTrands
        ? [...widgetmakerPostCardTrands]
        : [
            { widget_id: 0, chart_type: "user_profile", widget_loader: true },
            { widget_id: 1, chart_type: "kpi", widget_loader: true },
            { widget_id: 2, chart_type: "line", widget_loader: true },
            { widget_id: 3, chart_type: "donut", widget_loader: true },
            { widget_id: 4, chart_type: "wordcloud", widget_loader: true },
          ];

      //high chart option data clear start
      let updateOpData = global.options ? { ...global.options } : {};
      tab_array?.map((el) => {
        if (updateOpData?.[el?.chart_type]) delete updateOpData[el?.chart_type];
      });
      dispatch(setOptionHighChart(updateOpData));
      //high chart option data clear end
      if (
        e?.PlatformID === 3 &&
        e?.card_type === "User Post" &&
        !widgetmakerPostCardTrands
      ) {
        let arr = tab_array.filter((el, i) => {
          if (i < 2) return el;
        });
        tab_array = arr;
        dispatch(setWidgetMakerTrandArray(arr));
      }
      if (e?.card_type === "Brand Post" && !widgetmakerPostCardTrands) {
        let arr = tab_array.filter((el, i) => {
          if (i > 0) return el;
        });
        tab_array = arr;
        dispatch(setWidgetMakerTrandArray(arr));
      }
      dispatch(setWidgetMakerTrandArray(tab_array));
      setTrandView({
        modalShow: true,
        data: e,
      });
      tab_array = !widgetmakerPostCardTrands
        ? tab_array?.map((el, i) => {
            let obj = {
              ...el,
              card_type: e?.card_type,
              content_id: e?.PostContentID,
              brand_id: e?.PostBrandID,
              author_id: e?.AuthorAuthorID,
              post_id: e?.PostPostID,
              retweet_id: e?.RetweetedStatusID,
              reply_id: e?.InReplytostatusID,
              channel_group_id: e?.PlatformID,
              tag_id: e?.TagID ? e?.TagID : e?.tagid,
              utcOffset: utcOffset,
              offset: 0,
              isVerified: 0,
              sentimentType: {
                ispositive: 0,
                isnegative: 0,
                isneutral: 0,
              },
              trends_duration: el?.widget_id === 2 ? "eight_hours" : 0,
              isreply: 0,
              isretweet: 0,
              isreplywmedia: 0,
              attribute: "followers",
              sort_order: "desc",
              uniqueid: e?.uniqueid,
            };
            return obj;
          })
        : tab_array;
      if (e?.PlatformID === 3 && e?.card_type === "User Post") {
        tab_array?.forEach((el) => {
          authParams &&
            dispatch(setWidgetMakerPostCardTrends(authParams, el, tab_array));
        });
      } else {
        timer2 = setTimeout(() => {
          tab_array?.forEach((el) => {
            authParams &&
              dispatch(setWidgetMakerPostCardTrends(authParams, el, tab_array));
          });
        }, 200);
        // tab_array?.[
        //   id
        //     ? e?.card_type === "Brand Post"
        //       ? parseInt(id) - 1
        //       : parseInt(id)
        //     : 0
        // ]?.widget_id >= 0 &&
        //   authParams &&
        //   dispatch(
        //     setWidgetMakerPostCardTrends(
        //       authParams,
        //       tab_array[
        //         id
        //           ? e?.card_type === "Brand Post"
        //             ? parseInt(id) - 1
        //             : parseInt(id)
        //           : 0
        //       ],
        //       tab_array
        //     )
        //   );
      }
    }

    const commandCenter3DGlobePageId =
      authParams?.screen_id === "000-000-555" ? true : false;
    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
    };
  };
  const onExternal = (TicketID, PostBrandID) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      return;
    }
    setDeepLinkModal({
      url: null,
      modalShow: true,
    });
    let url =
      config1?.config1?.app_id === "10" || config1?.config1?.app_id === 10
        ? "https://preprodcx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "6" || config1?.config1?.app_id === 6
        ? window?.location?.origin?.includes("bbps.locobuzz.com") ||
          window?.location?.ancestorOrigins?.[0]?.includes("bbps.locobuzz.com")
          ? "https://bbps.locobuzz.com/ticketDetail"
          : "https://cx.locobuzz.com/ticketDetail"
        : config1?.config1?.app_id === "4" || config1?.config1?.app_id === 4
        ? window?.location?.origin?.includes("demo.locobuzz.com")
          ? "https://demo.locobuzz.com/ticketDetail"
          : window?.location?.origin?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            ) ||
            window?.location?.ancestorOrigins?.[0]?.includes(
              "locobuzzng-uat-aws.locobuzz.com"
            )
          ? "https://locobuzzng-uat-aws.locobuzz.com/ticketDetail"
          : "https://demo.locobuzz.com/ticketDetail"
        : "https://demo.locobuzz.com/ticketDetail";
    // : "https://demo.locobuzz.com/ticketDetail";

    let finalUrl = `${url}/${TicketID}/${PostBrandID}`;
    if (config1?.config1?.app_id === "2") {
      console.log("Deep Link URL =>", finalUrl);
    }
    // window.open(finalUrl);

    setDeepLinkModal({
      url: (
        <iframe
          title="Ticket Details"
          allowfullscreen={true}
          src={finalUrl}
          alt="Ticket Details"
          className="w-100 border-0 border-radius-4"
          style={{ height: "calc(100vh - 6.3rem)", marginTop: "3.7rem" }}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
        />
      ),
      modalShow: true,
    });
  };
  const handleDeepLinkOk = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const handleDeepLinkCancel = () => {
    setDeepLinkModal({
      url: null,
      modalShow: false,
    });
  };
  const idPresentFlag = unMaskedInfo?.tagids?.includes(el?.tagid);

  const handleGlobeClick = (el) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      return;
    }
    if (
      el?.latitude &&
      el?.latitude !== "NA" &&
      el?.longitude &&
      el?.longitude !== "NA"
    ) {
      let data = {
        latitude: el.latitude,
        longitude: el.longitude,
        sentimentType: el.SentimentType,
      };
      dispatch(setOnClickGlobeCoordinates(data));
    }
  };
  const commandCenter3DGlobePageId =
    authParams?.screen_id === "000-000-555" ? true : false;

  const footerMetaDataList = useMemo(
    () => footerMetaData?.map((d) => d?.attribute?.toLowerCase()),
    [footerMetaData]
  );

  if (el?.NumLikesCount === "NA") {
    el.NumLikesCount = 0;
  }
  if (el?.NumCommentsCount === "NA") {
    el.NumCommentsCount = 0;
  }
  if (el?.NumShareCount === "NA") {
    el.NumShareCount = 0;
  }
  if (el?.FollowersCount === "NA") {
    el.FollowersCount = 0;
  }
  const handleMaskUnMask = () => {
    // setMasked(masked === true ? false : true);
    setMasked(!masked);
    const PostCardDetails = {
      TagID: el?.tagid,
      PostBrandID: el?.PostBrandID,
      BrandName: el?.BrandName,
      ptoken: authParams?.ptoken,
      el: el,
      unMaskedInfoId: unMaskedInfoId,
      unMaskedInfo: unMaskedInfo,
    };
    if (masked) {
      dispatch(setUnmaskedInfo(PostCardDetails)); //To handle tagids array for idpresentflag
      if (!getunmaskedInfo) {
        dispatch(getUnmaskedInfo(PostCardDetails)); //Main api call to back end
        setGetunmaskedInfo(true); // Flag to not call api to  multiple times
      }
    } else {
      dispatch(setUnmaskedInfo(PostCardDetails)); //To handle tagids array for idpresentflag
    }
  };
  const handleHidePostModal = (data) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      return;
    }
    setHidePost({
      modalShow: true,
      data: data,
    });
  };

  const handleDeletePostModal = (data) => {
    if (personalizationSettingsObj?.isPersonalizationPreviewOpen) {
      return;
    }
    setDeletePost({
      modalShow: true,
      data: data,
    });
  };
  let firstAccentColor;
  let secondAccentColor;
  useEffect(() => {
    const selectedPalette = personalizationSettingsObj?.paletteList.find(
      (palette) => palette.isSelected
    );
    secondAccentColor = selectedPalette
      ? selectedPalette?.AccentColors?.[1]
      : personalizationSettingsObj?.paletteList?.[0]?.AccentColors?.[1];
    firstAccentColor = selectedPalette
      ? selectedPalette?.AccentColors?.[0]
      : personalizationSettingsObj?.paletteList?.[0]?.AccentColors?.[0];
  }, [personalizationSettingsObj]);
  return (
    <div>
      <div
        className={`${
          PdfDownloadStatus ? "px-15- ml-15 mr-15" : "p-15"
        } d-flex align-items-center card__footerWrap ${
          el?.PlatformID === 7 || el?.PlatformID === 30
            ? "justify-content-end mb-2"
            : "justify-content-between"
        } `}
      >
        {commandCenter3DGlobePageId && !isHideGlobal ? (
          <div className="card__footerWrap--inner no--wrap w-100">
            <Tooltip
              title="Hide post"
              className="mr-15 d-inline-flex align-items-center"
            >
              <div
                className={`${
                  personalizationSettingsObj?.isPersonalizationPreviewOpen
                    ? "disabled-cursor"
                    : "cursor-pointer"
                }`}
              >
                <img
                  src={HidePostIcon}
                  className="cardList__footer-label"
                  alt="Hide post"
                  onClick={(e) => handleHidePostModal(el)}
                />
              </div>
            </Tooltip>
            {!(
              workspace_privileges?.environment === 2 ||
              share_workspace_privileges?.environment === 2
            ) ? (
              <Tooltip
                title="Delete Post"
                className="mr-15 d-inline-flex align-items-center"
              >
                <div
                  className={`${
                    personalizationSettingsObj?.isPersonalizationPreviewOpen
                      ? "disabled-cursor"
                      : "cursor-pointer"
                  }`}
                >
                  <img
                    src={DeletePostIcon}
                    className="cardList__footer-label"
                    alt="Delete Post"
                    onClick={(e) => handleDeletePostModal(el)}
                  />
                </div>
              </Tooltip>
            ) : (
              ""
            )}

            <Tooltip
              title={
                el?.ContentLocation
                  ? el?.ContentLocation
                  : "No location available"
              }
              className="mr-15 d-inline-flex align-items-center"
            >
              <div
                className={`${
                  personalizationSettingsObj?.isPersonalizationPreviewOpen ||
                  !(
                    el?.latitude &&
                    el?.latitude !== "NA" &&
                    el?.longitude &&
                    el?.longitude !== "NA"
                  )
                    ? "disabled-cursor"
                    : "cursor-pointer"
                }`}
              >
                <img
                  src={Globe}
                  className={`${
                    authParams?.screen_id
                      ? "command_center_cardList__footer-label"
                      : "cardList__footer-label"
                  } `}
                  alt="Globe"
                  onClick={(e) => handleGlobeClick(el)}
                />
              </div>
            </Tooltip>
          </div>
        ) : (
          ""
        )}

        {el?.PlatformID !== 7 &&
        el?.PlatformID !== 30 &&
        !commandCenter3DGlobePageId ? (
          <div className="d-flex no--wrap w-100">
            {footerMetaDataList?.includes("numlikescount") &&
            el?.NumLikesCount >= 0 ? (
              <Tooltip
                title={el?.PlatformID === 36 ? "Upvotes" : "Likes"}
                className="mr-15 d-inline-flex align-items-center"
              >
                <div className="cursor-pointer">
                  <span
                    className={`${
                      authParams?.screen_id
                        ? "command_center_cardList__footer-label"
                        : "cardList__footer-label"
                    }`}
                  >
                    {(() => {
                      let iconType = "";

                      if (el?.PlatformID === 2 || el?.PlatformID === 4) {
                        iconType =
                          authParams?.theme_type === "1"
                            ? "facebook_like_white"
                            : "facebook_like";
                      } else if (el?.PlatformID === 36) {
                        iconType =
                          authParams?.theme_type === "1"
                            ? "upvote_white"
                            : "upvote";
                      } else {
                        iconType =
                          authParams?.theme_type === "1"
                            ? "like_white_icon"
                            : "like_icon";
                      }

                      return getDynamicChannelIcon(iconType);
                    })()}
                  </span>

                  {/* className={`${
                      authParams?.screen_id
                        ? "command_center_cardList__footer-label"
                        : "cardList__footer-label"
                    }`} */}

                  <span
                    className={`${
                      authParams?.screen_id === "000-000-562"
                        ? "text-yellow"
                        : "text-secondaryColor"
                    } cardList__footer-count customCardFollower`}
                    style={{
                      color: firstAccentColor
                        ? firstAccentColor
                        : "var(--color-yellow)",
                    }}
                  >
                    {/*add accent  */}
                    {kFormatter(el?.NumLikesCount)}
                  </span>
                </div>
              </Tooltip>
            ) : (
              ""
            )}
            {el?.AnswerCount >= 0 ||
            (footerMetaDataList?.includes("numcommentscount") &&
              el?.NumCommentsCount >= 0) ? (
              <Tooltip
                title={
                  el?.PlatformID === 36
                    ? "Answers"
                    : el?.PlatformID === 1
                    ? "Replies"
                    : "Comments"
                }
                className="mr-15 d-inline-flex align-items-center"
              >
                <div className="cursor-pointer">
                  <span
                    className={`${
                      authParams?.screen_id
                        ? "command_center_cardList__footer-label"
                        : "cardList__footer-label"
                    }`}
                  >
                    {authParams?.theme_type === "1"
                      ? getDynamicChannelIcon("comment_white_icon")
                      : getDynamicChannelIcon("comment_icon")}
                  </span>
                  {/* <img
                    src={
                      authParams?.theme_type === "1" ? commentwhite : comment
                    }
                    className={`${
                      authParams?.screen_id
                        ? "command_center_cardList__footer-label"
                        : "cardList__footer-label"
                    }`}
                    alt="comment"
                  /> */}
                  <span
                    className={`${
                      authParams?.screen_id === "000-000-562"
                        ? "text-yellow"
                        : "text-secondaryColor"
                    } cardList__footer-count customCardFollower`}
                    style={{
                      color: firstAccentColor
                        ? firstAccentColor
                        : "var(--color-yellow)",
                    }}
                  >
                    {el?.PlatformID === 36
                      ? kFormatter(el?.AnswerCount)
                      : kFormatter(el?.NumCommentsCount)}
                  </span>
                </div>
              </Tooltip>
            ) : (
              ""
            )}

            {(el?.PlatformID !== 3 ||
              (el?.PlatformID === 3 && el?.card_type === "Brand Post")) &&
            !commandCenter3DGlobePageId &&
            footerMetaDataList?.includes("numsharecount") &&
            el?.NumShareCount >= 0 ? (
              <Tooltip
                title={el?.PlatformID === 1 ? "Retweets" : "Share"}
                className="mr-15 d-inline-flex align-items-center"
              >
                <div className="cursor-pointer">
                  <span
                    style={{
                      color: firstAccentColor
                        ? firstAccentColor
                        : "var(--color-yellow)",
                    }}
                    className={`${
                      authParams?.screen_id
                        ? "command_center_cardList__footer-label"
                        : "cardList__footer-label"
                    }`}
                  >
                    {" "}
                    {el?.PlatformID === 2
                      ? authParams?.theme_type === "1"
                        ? getDynamicChannelIcon("facebook_share_white")
                        : getDynamicChannelIcon("facebook_share")
                      : el?.PlatformID === 4 || el?.PlatformID === 5
                      ? authParams?.theme_type === "1"
                        ? getDynamicChannelIcon("youtube_share_white")
                        : getDynamicChannelIcon("youtube_share")
                      : el?.PlatformID === 1
                      ? authParams?.theme_type === "1"
                        ? getDynamicChannelIcon("retweet_white_icon")
                        : getDynamicChannelIcon("retweet_icon")
                      : el?.PlatformID === 36
                      ? authParams?.theme_type === "1"
                        ? getDynamicChannelIcon("share_q_white_icon")
                        : getDynamicChannelIcon("share_q_icon")
                      : el?.PlatformID === 3
                      ? authParams?.theme_type === "1"
                        ? getDynamicChannelIcon("instagram_share_white")
                        : getDynamicChannelIcon("instagram_share")
                      : authParams?.theme_type === "1"
                      ? getDynamicChannelIcon("youtube_share_white")
                      : getDynamicChannelIcon("youtube_share")}
                  </span>

                  <span
                    style={{
                      color: firstAccentColor
                        ? firstAccentColor
                        : "var(--color-yellow)",
                    }}
                    className={`${
                      authParams?.screen_id === "000-000-562"
                        ? "text-yellow"
                        : "text-secondaryColor"
                    } cardList__footer-count customCardFollower`}
                  >
                    {kFormatter(el?.NumShareCount)}
                  </span>
                </div>
              </Tooltip>
            ) : (
              ""
            )}
            {(el?.MediaType === 3 ||
              el?.NumVideoViews > 0 ||
              el?.PlatformID === 36) &&
            footerMetaDataList?.includes("numvideoviews") &&
            el?.NumVideoViews >= 0 ? (
              <Tooltip
                title="Views"
                className="mr-15 d-inline-flex align-items-center"
              >
                <div className="cursor-pointer">
                  {(el?.MediaType === 3 ||
                    el?.NumVideoViews > 0 ||
                    el?.PlatformID === 36) &&
                  authParams?.theme_type === "1"
                    ? getDynamicChannelIcon("video_view_white")
                    : getDynamicChannelIcon("video_view")}

                  <span
                    style={{
                      color: firstAccentColor
                        ? firstAccentColor
                        : "var(--color-yellow)",
                    }}
                    className={`${
                      authParams?.screen_id === "000-000-562"
                        ? "text-yellow"
                        : "text-secondaryColor"
                    } cardList__footer-count customCardFollower`}
                  >
                    {kFormatter(el?.NumVideoViews)}
                  </span>
                </div>
              </Tooltip>
            ) : (
              ""
            )}
            {(el?.PlatformID === 2 || el?.PlatformID === 5) &&
            el?.Posttype === "Brand Post" &&
            el?.post_clicks >= 0 ? (
              <Tooltip
                title="Post Clicks"
                className="mr-15 d-inline-flex align-items-center"
              >
                <div className="cursor-pointer">
                  <span
                    className={`${
                      authParams?.screen_id
                        ? "command_center_cardList__footer-label"
                        : "cardList__footer-label"
                    }`}
                  >
                    {authParams?.theme_type === "1"
                      ? getDynamicChannelIcon("postClick_white")
                      : getDynamicChannelIcon("postClick_black")}
                  </span>
                  {/* <img
                    src={
                      authParams?.theme_type === "1"
                        ? postClickWhite
                        : postClickBlack
                    }
                    className={`${
                      authParams?.screen_id
                        ? "command_center_cardList__footer-label"
                        : "cardList__footer-label"
                    }`}
                    alt="Post Clicks"
                  /> */}
                  <span
                    style={{
                      color: firstAccentColor
                        ? firstAccentColor
                        : "var(--color-yellow)",
                    }}
                    className={`cardList__footer-count ${
                      authParams?.screen_id === "000-000-562"
                        ? " text-yellow"
                        : "text-secondaryColor"
                    } customCardFollower`}
                  >
                    {kFormatter(el?.post_clicks)}
                  </span>
                </div>
              </Tooltip>
            ) : (
              ""
            )}
            {el?.Interaction > 0 && el?.Interaction ? (
              <Tooltip
                title="the total number of interactions with this Author"
                className="mr-15 d-inline-flex align-items-center"
              >
                <div className="cursor-pointer">
                  <img
                    src={Interaction}
                    className={`${
                      authParams?.screen_id
                        ? "command_center_cardList__footer-label"
                        : "cardList__footer-label"
                    }`}
                    alt="Interaction"
                  />
                  <span className="cardList__footer-count text-Darkgray customCardFollower">
                    {kFormatter(el?.Interaction)}
                  </span>
                </div>
              </Tooltip>
            ) : (
              ""
            )}
            {PdfDownloadStatus &&
            el?.PlatformID === 1 &&
            el?.EmailContentHtml &&
            el?.EmailContentHtml !== "NA" &&
            el?.Followers >= 0 ? (
              <Tooltip
                title="the total number of interactions with this Author"
                className="mr-15 d-inline-flex align-items-center"
              >
                <div className="cursor-pointer">
                  <img
                    src={userFollowers}
                    className={`${
                      authParams?.screen_id
                        ? "command_center_cardList__footer-label"
                        : "cardList__footer-label"
                    }`}
                    alt="userFollowers"
                  />
                  <span className="cardList__footer-count text-Darkgray customCardFollower">
                    {kFormatter(el?.Followers)}
                  </span>
                </div>
              </Tooltip>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}
        {el?.IsDarkPost ? (
          <span className="trands blue-text font-size14 cursor-pointer mr-2">
            <Tooltip title="Dark Post">
              <img
                alt="is Dark Post"
                src={IsDarkPost}
                style={{ width: "1.8rem", height: "1.8rem" }}
                className="mr-0 "
              />
            </Tooltip>
          </span>
        ) : (
          ""
        )}

        {/* MASK UNMASK ICON */}
        {el?.IsMaskedMention &&
        !commandCenter3DGlobePageId &&
        footerMetaDataList?.includes("ismaskedmention") &&
        footerMetaData &&
        Array.isArray(footerMetaData) &&
        footerMetaData?.findIndex(
          (f) =>
            String(f?.attribute)?.toLowerCase() ===
              String("IsMaskedMention")?.toLowerCase() && f?.show_icon
        ) !== -1 ? (
          <div
            className={`d-flex cursor-pointer padding-1 mr-1`}
            onClick={handleMaskUnMask}
          >
            <Tooltip
              title={idPresentFlag ? "Hide Masked Data" : "View Masked Data"}
            >
              <img
                className="maskedunmaskedCustomCard trands"
                src={idPresentFlag ? UnMaskimgCC : MaskimgCC}
                alt=""
              />
            </Tooltip>
          </div>
        ) : (
          ""
        )}

        {!commandCenter3DGlobePageId &&
        footerMetaDataList?.includes("url") &&
        footerMetaData &&
        Array.isArray(footerMetaData) &&
        footerMetaData?.findIndex(
          (f) =>
            String(f?.attribute)?.toLowerCase() ===
              String("URL")?.toLowerCase() && f?.show_icon
        ) !== -1 ? (
          <Tooltip
            title={
              personalizationSettingsObj?.isPersonalizationPreviewOpen
                ? "Actions are not allowed while customizing"
                : el?.PostURL && el?.PostURL?.trim() && el?.PostURL !== "NA"
                ? "Open Post"
                : "Post URL is not available"
            }
          >
            {el?.PostURL && el?.PostURL?.trim() && el?.PostURL !== "NA" ? (
              <a
                className={`trands blue-text font-size14 ${
                  personalizationSettingsObj?.isPersonalizationPreviewOpen
                    ? "disabled-cursor"
                    : "cursor-pointer"
                } mr-2`}
                href={el?.PostURL}
                target="_blank"
                onClick={(e) => {
                  if (
                    personalizationSettingsObj?.isPersonalizationPreviewOpen
                  ) {
                    e.preventDefault();
                  }
                }}
                rel="noreferrer"
                style={{
                  marginTop: "0.3rem",
                }}
              >
                <i
                  class={`fas fa-external-link-alt ${
                    authParams?.screen_id === "000-000-565"
                      ? "command_center_open_post_icon"
                      : ""
                  } ${
                    personalizationSettingsObj?.isPersonalizationPreviewOpen
                      ? "disabled-cursor"
                      : ""
                  }`}
                />
              </a>
            ) : (
              <span
                style={{
                  marginTop: "0.3rem",
                  display: "inline-block",
                  opacity: "0.4",
                }}
                className="blue-text font-size14 mr-2"
              >
                <i className={`fas fa-external-link-alt`} />
              </span>
            )}
          </Tooltip>
        ) : (
          ""
        )}

        {/* Ticket Details */}
        {el?.TicketID > 0 &&
        !commandCenter3DGlobePageId &&
        footerMetaData &&
        Array.isArray(footerMetaData) &&
        footerMetaData?.findIndex(
          (f) =>
            String(f?.attribute)?.toLowerCase() ===
            String("TicketID")?.toLowerCase()
        ) !== -1 ? (
          <div
            className={`trands ${
              personalizationSettingsObj?.isPersonalizationPreviewOpen
                ? "disabled-cursor"
                : "cursor-pointer"
            } mr-2`}
            onClick={() => onExternal(el?.TicketID, el?.PostBrandID)}
          >
            <Tooltip title="Ticket Details">
              <img
                src={authParams?.screen_id ? deepLinkIconCC : deepLinkIcon}
                className={`${
                  authParams?.screen_id
                    ? "command_center_cardList__footer-label"
                    : "cardList__footer-label"
                }`}
                alt="Deep Link Icon"
                style={{ maxWidth: "1.8rem", width: "1.8rem" }}
              />
            </Tooltip>
          </div>
        ) : (
          ""
        )}

        {/* Created date */}
        {/* {footerMetaDataList?.includes("createddate") && el?.CreatedDate ? (
          <div style={{ padding: "0rem 0.2rem" }}>
            <Tooltip
              title={
                <div>
                  Created Date : <br />{" "}
                  {el?.CreatedDate_tooltip
                    ? el?.CreatedDate_tooltip
                    : el?.CreatedDate}
                </div>
              }
              className="no--wrap d-flex align-items-center"
            >
              <img
                src={ClockIcon}
                className="cardList__footer-label"
                alt="ClockIcon"
              />
              <span className="cardList__footer-count text-grayLight">
                {el?.CreatedDate}
              </span>
            </Tooltip>
          </div>
        ) : (
          ""
        )} */}

        {el?.PlatformID === 19 || el?.PlatformID === "News"
          ? ""
          : !(el?.card_type === "User Post" && el?.PlatformID === 5) &&
            !commandCenter3DGlobePageId &&
            (postDetail ||
            footerMetaData?.findIndex(
              (f) =>
                String(f?.attribute)?.toLowerCase() ===
                String("Trends")?.toLowerCase()
            ) === -1 ? (
              ""
            ) : (
              <div
                className={`mr-2 trands ${
                  isPreviewState ? "" : "cursor-pointer"
                } ${el?.CreatedDate === "a moment ago" ? "disable" : ""} ${
                  personalizationSettingsObj?.isPersonalizationPreviewOpen
                    ? "disabled-cursor"
                    : ""
                }`}
                onClick={() => !isPreviewState && handleTrends(el)}
              >
                <Tooltip
                  title={
                    personalizationSettingsObj?.isPersonalizationPreviewOpen
                      ? "Actions are not allowed while customizing"
                      : "Trends"
                  }
                >
                  <span
                    className={`${
                      authParams?.screen_id === "000-000-565"
                        ? "command_center_trend_icon"
                        : authParams?.screen_id
                        ? "command_center_cardList__footer-label"
                        : "cardList__footer-label"
                    }`}
                  >
                    {authParams?.screen_id === "000-000-565"
                      ? getCommandCenterIcon("mention_dashboard_trends_icon")
                      : getDynamicIconColor("trends_icon")}
                  </span>
                  {/* <img src={trendsIcon} alt="trends Icon" /> */}
                </Tooltip>
              </div>
            ))}

        {/* Created date */}
        {footerMetaDataList?.includes("createddate") && el?.CreatedDate ? (
          <>
            <Tooltip
              title={
                <div>
                  Created Date : <br />{" "}
                  {el?.CreatedDate_tooltip
                    ? el?.CreatedDate_tooltip
                    : el?.CreatedDate}
                </div>
              }
              className="no--wrap d-flex align-items-center"
              style={{ color: "var(--cc-widget-text-secondaryColor)" }}
            >
              <span
                className={`${
                  authParams?.screen_id
                    ? "command_center_cardList__footer-label  text-secondaryColor"
                    : "cardList__footer-label"
                }`}
              >
                {getDynamicIconColor("clock_icon")}
              </span>
              {/* <img
                src={ClockIcon}
                className={`${
                  authParams?.screen_id
                    ? "command_center_cardList__footer-label  text-secondaryColor"
                    : "cardList__footer-label"
                }`}
                alt="ClockIcon"
              /> */}
              <span className="cardList__footer-count  text-secondaryColor customCardFollower">
                {el?.CreatedDate}
              </span>
            </Tooltip>
          </>
        ) : (
          ""
        )}
      </div>

      {trandView?.modalShow && (
        <Modal
          title={null}
          visible={trandView?.modalShow}
          closable={false}
          className={`trandsPopup ${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          }`}
          footer={null}
        >
          <TrandsView
            trendValue={trendValue}
            cardData={trandView?.data}
            setTrandView={setTrandView}
            handleTrends={handleTrends}
            PdfDownloadStatus={PdfDownloadStatus}
            PptGeneratingStatus={PptGeneratingStatus}
            deepDive={deepDive}
            setAutoPlay={setAutoPlay}
          />
        </Modal>
      )}
      {deepLinkModal?.modalShow && (
        <Modal
          title={null}
          visible={deepLinkModal?.modalShow}
          style={{ width: "100%", top: "1rem", paddingBottom: "1rem" }}
          onOk={handleDeepLinkOk}
          onCancel={handleDeepLinkCancel}
          width="100%"
          footer={null}
          className={`deepLinkModal ${
            authParams?.theme_type === "1" ? "darkTheme" : "lightTheme"
          }`}
        >
          {!deepLinkModal?.url ? (
            <div
              className="loader mx-auto"
              style={{ height: "calc(100vh - 2.6rem)" }}
            >
              <div className="lds-ring">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            deepLinkModal?.url
          )}
        </Modal>
      )}

      {/* Hide Post Modal */}
      {hidePost?.modalShow && (
        <HidePostModal
          isOpen={hidePost?.modalShow}
          setHidePost={setHidePost}
          hidePost={hidePost}
        />
      )}

      {/* Delete Post Modal */}
      {deletePost?.modalShow && (
        <DeletePost
          isOpen={deletePost?.modalShow}
          setDeletePost={setDeletePost}
          deletePost={deletePost}
        />
      )}
    </div>
  );
};

export default React.memo(CustomFooterContent, isEqual);
